import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TabExpIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TabExpIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M11.1299 7.09009C11.1299 9.29923 9.33902 11.0901 7.12988 11.0901C4.92074 11.0901 3.12988 9.29923 3.12988 7.09009C3.12988 4.88095 4.92074 3.09009 7.12988 3.09009C9.33902 3.09009 11.1299 4.88095 11.1299 7.09009Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.8949 3.96518C20.5551 3.42101 19.9588 3.09009 19.3176 3.09009H15.9422C15.3003 3.09009 14.7046 3.42101 14.3642 3.96518L12.8136 6.44872C12.5687 6.84141 12.5687 7.33942 12.8136 7.73145L14.3642 10.215C14.704 10.7592 15.3003 11.0901 15.9422 11.0901H19.3176C19.9588 11.0901 20.5551 10.7592 20.8955 10.215L22.4462 7.73145C22.6911 7.33877 22.6911 6.84076 22.4462 6.44872L20.8949 3.96518Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M5.10608 13.0903H5.13926C5.98776 13.0903 6.7385 13.5267 7.19238 14.1942C7.66113 13.4837 8.36342 13.0903 9.18926 13.0903H9.22095C9.30164 13.089 9.38347 13.0945 9.46415 13.1062C9.94306 13.1632 10.3805 13.3679 10.7349 13.6768C11.2415 14.1187 11.578 14.7726 11.6235 15.5117L11.6241 15.5136C11.6282 15.5706 11.6299 15.6282 11.6299 15.6864C11.6299 15.7446 11.6276 15.8022 11.6241 15.8592V17.0053C11.6241 17.5777 11.3613 18.1146 10.9199 18.4431L7.80729 20.8842C7.62288 21.0214 7.40734 21.0901 7.19238 21.0901C6.97078 21.0901 6.74976 21.0214 6.55956 20.8841L3.35929 18.4427C2.90541 18.1141 2.63522 17.5772 2.63522 17.0047V15.856C2.63166 15.7996 2.62988 15.7432 2.62988 15.6856C2.62988 15.6279 2.63166 15.5709 2.63522 15.5145C2.68143 14.7747 3.02806 14.1194 3.54949 13.6769C3.9139 13.3679 4.36304 13.1632 4.85543 13.1062C4.93839 13.0945 5.02253 13.089 5.10608 13.0903Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.3459 20.4468H21.9138C22.1693 20.4468 22.3775 20.2387 22.3775 19.9832V19.1883C22.3775 18.973 22.2285 18.7932 22.0227 18.7388C21.4052 18.5755 20.951 18.0125 20.951 17.3453C20.951 16.6782 21.4052 16.1152 22.0227 15.9519H22.025C22.2332 15.8975 22.3799 15.7154 22.3799 15.5024V14.5538C22.3799 14.2983 22.1717 14.0901 21.9162 14.0901H13.3436C13.0881 14.0901 12.8799 14.2983 12.8799 14.5538V15.5024C12.8799 15.7154 13.0266 15.8975 13.2347 15.9519H13.2371C13.8546 16.1152 14.3088 16.6782 14.3088 17.3453C14.3088 18.0125 13.8546 18.5755 13.2371 18.7388C13.0313 18.7932 12.8822 18.973 12.8822 19.1883V19.9832C12.8822 20.2387 13.0904 20.4468 13.3459 20.4468Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default TabExpIcon;
